export default {
  name: 'TriggerAdder',
  props: ['all_triggers', 'integrations'],
  emits: ['success'],
  computed: {
    selectedProvider: function selectedProvider() {
      var selectedProviderKey = this.trigger.trigger_provider;
      if (!selectedProviderKey) {
        return false;
      }
      return this.all_triggers[selectedProviderKey];
    },
    selectedRemoteIntegrations: function selectedRemoteIntegrations() {
      var _this = this;
      if (!this.selectedProvider) {
        return [];
      }
      return this.integrations.filter(function (integration) {
        return integration.provider == _this.trigger.trigger_provider;
      });
    }
  },
  data: function data() {
    return {
      trigger: {
        title: '',
        integration_id: '',
        trigger_name: '',
        trigger_provider: '',
        status: 'draft',
        settings: {}
      }
    };
  },
  methods: {
    changeTriggerProvider: function changeTriggerProvider(provider) {
      var _this2 = this;
      this.trigger.trigger_provider = provider;
      this.$nextTick(function () {
        if (_this2.selectedRemoteIntegrations.length > 0) {
          _this2.trigger.integration_id = _this2.selectedRemoteIntegrations[0].id;
        }
      });
    },
    triggerSuccess: function triggerSuccess() {
      this.trigger.is_open = true;
      this.$emit('success', this.trigger);
      this.trigger = {
        title: '',
        integration_id: '',
        trigger_name: '',
        trigger_provider: '',
        status: 'draft',
        settings: {}
      };
    }
  },
  mounted: function mounted() {
    this.changeTriggerProvider('thrivecart');
  }
};